import AbstractRepository from "@/repositories/AbstractRepository";

export default class MediaCampaignRepository extends AbstractRepository {
    protected static resource: string = "pml-spirit-mediacampaign";

    public static defaultFields: string[] = [
        "uuid",
        "title",
        "status",
        "code",
        "beginDate",
        "endDate"
    ];
}
